import { useState } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import API from '../../../api/axios';
import { APP_URLS } from '../../../api/url';
import { toast } from 'react-toastify';
import { APIError } from '../../../core/utils';

// Styled Components
const ModalWrapper = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
}));

const ScamMessageSelect = styled('select')(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
    fontSize: '0.9rem',
    outline: 'none',
    '&:focus': {
        borderColor: theme.palette.primary.main,
    },
}));

const RemoveData = ({ flaggedId, actionloader, _actionloader, getReportedUsers, scamMessages }) => {

    const [open, setOpen] = useState(false);
    const [scamMessage, _scamMessage] = useState('');

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
    };

    const handleRemoveData = () => {
        if (actionloader) return;

        if (!scamMessage) {
            toast.error("Please select a broadcast message for all the chats of the user")
            return
        }

        _actionloader(true);

        API.post(`${APP_URLS.LIST_FLAGGED_USERS}/remove_flag_user_data/${flaggedId}`, {
            scammer_message_id: scamMessage
        })
            .then((res) => {
                const resp = res.data;
                if (resp.success === true) {
                    toast.success(`All of the chats and ads associated with the user has been removed successfully`, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    getReportedUsers();
                } else {
                    toast.error(resp.message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            })
            .catch(function (error) {
                let error_message = APIError(error);
                toast.error(error_message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            })
            .finally(() => {
                _actionloader(false);
            });

        handleClose();
    };

    return (
        <>
            <button className="reject" onClick={handleOpen}>
                Remove Data
            </button>
            <Modal open={open} onClose={handleClose}>
                <ModalWrapper>
                    <Typography variant="h6" mb={2}>
                        Confirm Removal
                    </Typography>
                    <Typography mb={2}>
                        This will permanently remove all chats associated with this user.
                    </Typography>

                    <ScamMessageSelect
                        name="scam-message"
                        value={scamMessage}
                        onChange={(e) => _scamMessage(e.target.value)}
                    >
                        <option value="" disabled>
                            Choose broadcast message for all chats of the user
                        </option>
                        {scamMessages.map((message) => {
                            const truncatedName =
                                message.name.length > 50
                                    ? `${message.name.slice(0, 47)}...`
                                    : message.name;
                            return (
                                <option key={message.id} value={message.id} title={message.name}>
                                    {truncatedName}
                                </option>
                            );
                        })}
                    </ScamMessageSelect>

                    <Box display="flex" justifyContent="flex-end" gap={1}>
                        <Button onClick={handleClose} variant="outlined">
                            Cancel
                        </Button>
                        <Button
                            onClick={handleRemoveData}
                            variant="contained"
                            color="error"
                            disabled={actionloader}
                        >
                            Confirm
                        </Button>
                    </Box>
                </ModalWrapper>
            </Modal>
        </>
    );
};

export default RemoveData;
